import { render } from "./pagerduty.vue?vue&type=template&id=7db01039"
import script from "./pagerduty.vue?vue&type=script&lang=js"
export * from "./pagerduty.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__